
















































































































































































































































































































































































































































import moment from "moment";
import { Component, Mixins, Prop } from "vue-property-decorator";
import AsesmenAnakGadar from "@/components/AsesmenAwalGadar/AsesmenAnakGadar.vue";
import {
	DOWN_KEYS,
	DownItems,
	downAdaIsian,
	downItemsKosong,
	downNormalizeItems,
} from "@/utils/downScore";
import {
	SAGA_KEYS,
	SagaItems,
	sagaAdaIsian,
	sagaItemsKosong,
	sagaNormalizeItems,
} from "@/utils/sagaAnak";
import AsesmenLain from "@/components/AsesmenAwalGadar/AsesmenLain.vue";
import AsesmenNyeri from "@/components/AsesmenAwalGadar/AsesmenNyeri.vue";
import TandaVital from "@/components/AsesmenAwalGadar/TandaVital.vue";
import {
	deriveTriaseSurveyPrimer,
	toTriaseInput,
	triaseLevelToKategoriId,
} from "@/pages/PemeriksaanIgdPage/triaseSurveyPrimer";
import AsesmenAwalGadar from "@/services/AsesmenAwalGadar/AsesmenAwalGadar";
import AsesmenSurveyPrimerGadar from "@/services/AsesmenAwalGadar/AsesmenSurveyPrimerGadar";
import AsesmenSurveyPrimerGadarStore from "@/store/modules/AsesmenAwalGadar/AsesmenSurveyPrimerGadarStore";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import HydrationGuard from "@/mixins/HydrationGuard";
import { userModule } from "@/store/modules/user";
import type { Nyeri, TTV } from "@/types/asesmen";
import type {
	AsesmenAnakGadarValue,
	RiwayatSurveyPrimerGadar,
} from "@/types/asesmen_gawat_darurat";

@Component({
	components: {
		TandaVital,
		AsesmenLain,
		AsesmenNyeri,
		AsesmenAnakGadar,
	},
	inject: { isReadOnly: { default: () => () => false } },
})
export default class SurveyPrimerGadarPage extends Mixins(HydrationGuard) {
	@Prop() readonly register!: number;
	@Prop() readonly rm!: number;

	isReadOnly!: () => boolean;
	get readOnly(): boolean {
		return this.isReadOnly();
	}

	selectProps = { openOnHover: true, offsetY: true };

	airwayOptions = [
		{ id: 1, name: "Dispnoe" },
		{ id: 2, name: "Stridor" },
		{ id: 3, name: "Snoring" },
		{ id: 4, name: "Wheezing" },
		{ id: 5, name: "Gurgling" },
		{ id: 6, name: "Paten" },
	];
	pernapasanOptions = [
		{ id: 1, name: "Spontan" },
		{ id: 2, name: "Tak Spontan" },
	];
	dadaOptions = [
		{ id: 1, name: "Simetris" },
		{ id: 2, name: "Asimetris" },
	];
	pernapasanTypeOptions = [
		{ id: 1, name: "Normal" },
		{ id: 2, name: "Apneu" },
		{ id: 3, name: "Takipneu" },
		{ id: 4, name: "Bardipneu" },
		{ id: 5, name: "Biot" },
		{ id: 6, name: "Cheyne Stoke" },
		{ id: 7, name: "Kusmaul" },
		{ id: 8, name: "Ortopnoe" },
	];
	klinisOptions = [
		{ id: 1, name: "Retraksi" },
		{ id: 2, name: "Cuping Hidung" },
	];
	nadiOptions = [
		{ id: 1, name: "Reguler" },
		{ id: 2, name: "Ireguler" },
		{ id: 3, name: "Kuat" },
		{ id: 4, name: "Lemah" },
	];
	nadiOptions1 = [
		{ id: 1, name: "Reguler" },
		{ id: 2, name: "Ireguler" },
	];
	nadiOptions2 = [
		{ id: 3, name: "Kuat" },
		{ id: 4, name: "Lemah" },
	];
	kulitOptions = [
		{ id: 1, name: "Normal" },
		{ id: 2, name: "Sianosis" },
		{ id: 3, name: "Jaundice" },
		{ id: 4, name: "Diaphoresis" },
		{ id: 5, name: "Pucat" },
	];
	akralOptions = [
		{ id: 1, name: "Hangat" },
		{ id: 2, name: "Dingin" },
	];
	crtOptions = [
		{ id: 1, name: "< 2 detik" },
		{ id: 2, name: "> 2 detik" },
	];
	eksposurOptions = [
		{ id: 1, name: "Deformitas" },
		{ id: 2, name: "Penetrasi" },
		{ id: 3, name: "Burn" },
		{ id: 4, name: "Perforasi" },
		{ id: 5, name: "Jejas" },
		{ id: 6, name: "Laserasi" },
		{ id: 7, name: "Krepitasi" },
		{ id: 8, name: "Abrasi" },
	];
	kesadaranOptions = [
		{ id: 1, name: "Alert" },
		{ id: 2, name: "Voice response" },
		{ id: 3, name: "Pain response" },
		{ id: 4, name: "Unresponse" },
		{ id: 5, name: "Tidak Dapat Dinilai (TDD)" },
	];
	pupilReflekOptions = [
		{ id: 1, name: "Isokor" },
		{ id: 2, name: "Anisokor" },
		{ id: 3, name: "Medriasi maximal" },
		{ id: 4, name: "Pinpoint" },
	];
	// reflekCahayaOptions = [
	//   { id: 1, name: "Positif" },
	//   { id: 2, name: "Negatif" }
	// ];
	lateralisasiOptions = [
		{ id: 1, name: "Kanan" },
		{ id: 2, name: "Kiri" },
		{ id: 0, name: "Tidak ada" },
	];

	id = null;

	airway = [];
	pernapasan = null;
	dada = null;
	pernapasanType = null;
	klinis = null;
	nadi = null;
	kulit = null;
	akral = null;
	crt = null;
	kesadaran = null;
	pupilReflek = null;
	pupilDiameter = null;
	reflekCahaya = null;
	lateralisasi = null;
	eksposur = null;

	tvSistole = null;
	tvDiastole = null;
	tvNadi = null;
	tvNafas = null;
	tvSuhu = null;
	tvSaturasiO2 = null;
	ttvId = null;

	gcsEye = null;
	gcsVerbal = null;
	gcsMotor = null;
	asesKesadaranId = null;

	asesRisjat = null;
	asesRisjatId = null;

	asesKecemasan = null;
	asesKecemasanId = null;

	nyeriSkala = 0;
	nyeriLokasi = null;
	nyeriFrekuensi = null;
	nyeriDurasi = null;
	nyeriPencetus = null;
	nyeriKualitas = null;
	nyeriPolaSerangan = null;
	nyeriPenyebabHilang = null;
	nyeriJenis = null;
	nyeriId = null;

	isDoa = false;

	asesmenAnakId = null;
	anakDownScore = null;
	anakApgar1min = null;
	anakApgar5min = null;
	anakBeratBadan = null;
	anakTinggiBadan = null;
	anakSaga: SagaItems = sagaItemsKosong();
	anakDown: DownItems = downItemsKosong();

	saving = false;

	riwayat: RiwayatSurveyPrimerGadar[] = [];
	expandedRiwayat: RiwayatSurveyPrimerGadar[] = [];
	modeRetriase = false;

	riwayatHeaders = [
		{ text: "No", value: "urutan", sortable: false, width: 90 },
		{ text: "Waktu", value: "waktu", sortable: false, width: 140 },
		{ text: "Petugas", value: "petugas", sortable: false, width: 160 },
		{ text: "Triase", value: "triase", sortable: false, width: 190 },
		{ text: "Temuan", value: "temuan", sortable: false },
		{ text: "", value: "data-table-expand", sortable: false, width: 40 },
	];

	get storeSurvey() {
		return AsesmenSurveyPrimerGadarStore;
	}

	get stateUser() {
		return userModule.user;
	}

	get pasienRm() {
		return (
			this.rm ||
			storePasien.identitasPasien?.rm ||
			this.storeSurvey.asesmen?.pasien_rm ||
			null
		);
	}

	get terkunci(): boolean {
		return this.busy || this.saving;
	}

	get usiaPasienTahun(): number | null {
		const tglLahirStr = storePasien.identitasPasien?.tgl_lahir;
		if (!tglLahirStr) return null;

		const parts = tglLahirStr.split("-");
		const tglLahir =
			parts.length === 3
				? new Date(
						parseInt(parts[2]),
						parseInt(parts[1]) - 1,
						parseInt(parts[0]),
					)
				: new Date(tglLahirStr);
		if (isNaN(tglLahir.getTime())) return null;

		const now = new Date();
		let usia = now.getFullYear() - tglLahir.getFullYear();
		const m = now.getMonth() - tglLahir.getMonth();
		if (m < 0 || (m === 0 && now.getDate() < tglLahir.getDate())) usia--;

		return usia;
	}

	get sudahAdaIsianAnak(): boolean {
		return (
			!!(
				this.asesmenAnakId ||
				this.anakDownScore ||
				this.anakApgar1min ||
				this.anakApgar5min ||
				this.anakBeratBadan ||
				this.anakTinggiBadan
			) ||
			sagaAdaIsian(this.anakSaga) ||
			downAdaIsian(this.anakDown)
		);
	}

	get showAsesmenAnak(): boolean {
		if (!storePasien.identitasPasien) return this.sudahAdaIsianAnak;

		const usia = this.usiaPasienTahun;
		return usia === null || usia < 18 || this.sudahAdaIsianAnak;
	}

	get triase() {
		return deriveTriaseSurveyPrimer(
			toTriaseInput({
				airway: this.airway,
				pernapasan: this.pernapasan,
				pernapasanType: this.pernapasanType,
				klinis: this.klinis,
				dada: this.dada,
				nadi: this.nadi,
				kulit: this.kulit,
				akral: this.akral,
				crt: this.crt,
				kesadaran: this.kesadaran,
				pupilReflek: this.pupilReflek,
				reflekCahaya: this.reflekCahaya,
				eksposur: this.eksposur,
				isDoa: this.isDoa,
			}),
		);
	}

	get input() {
		return {
			id: this.id,
			pasien_rm: this.pasienRm,
			register_id: this.register,
			a_airway: this.airway,
			b_pernapasan: this.pernapasan,
			b_dada: this.dada,
			b_pernapasan_type: this.pernapasanType,
			b_klinis: this.klinis,
			c_nadi: this.nadi,
			c_kulit: this.kulit,
			c_akral: this.akral,
			c_crt: this.crt,
			d_kesadaran: this.kesadaran,
			d_pupil_reflek: this.pupilReflek,
			d_lateralisasi: this.lateralisasi,
			d_pupil_diameter: this.pupilDiameter,
			d_reflek_cahaya: this.reflekCahaya,
			e_eksposur: this.eksposur,
			is_doa: this.isDoa,
			user_id: this.stateUser?.id,
			asesmen_anak: {
				id: this.asesmenAnakId,
				apgar1min: this.anakApgar1min,
				apgar5min: this.anakApgar5min,
				bb: this.anakBeratBadan,
				tb: this.anakTinggiBadan,
				saga: { ...this.anakSaga },
				down_items: { ...this.anakDown },
			},
			asesmen_kesadaran: !this.isDoa && this.isAnyAsesKesadaranInputed
				? {
						id: this.asesKesadaranId,
						pasien_rm: this.pasienRm,
						register_id: this.register,
						unit_id: this.stateUser.unit_id,
						e: this.gcsEye,
						v: this.gcsVerbal,
						m: this.gcsMotor,
						examined_at: "",
						perawat_id: this.stateUser?.id,
					}
				: null,
			asesmen_kecemasan: !this.isDoa && this.isAnyAsesKecemasanInputed
				? {
						id: this.asesKecemasanId,
						pasien_rm: this.pasienRm,
						register_id: this.register,
						unit_id: this.stateUser.unit_id,
						level: this.asesKecemasan,
						examined_at: "",
						perawat_id: this.stateUser?.id,
					}
				: null,
			asesmen_nyeri: !this.isDoa && this.isAnyAsesNyeriInputed
				? {
						id: this.nyeriId,
						skala: this.nyeriSkala,
						lokasi: this.nyeriLokasi,
						frekuensi: this.nyeriFrekuensi,
						durasi: this.nyeriDurasi,
						pencetus: this.nyeriPencetus,
						kualitas: this.nyeriKualitas,
						pola_serangan: this.nyeriPolaSerangan,
						penyebab_hilang: this.nyeriPenyebabHilang,
						jenis: this.nyeriJenis,
						unit_id: this.stateUser.unit_id,
					}
				: null,
			asesmen_risjat: !this.isDoa && this.isAnyAsesRisjatInputed
				? {
						id: this.asesRisjatId,
						pasien_rm: this.pasienRm,
						register_id: this.register,
						unit_id: this.stateUser.unit_id,
						risiko: this.asesRisjat > 0 ? 1 : 0,
						level: this.asesRisjat,
						waktu_periksa: moment().format("YYYY-MM-DD HH:mm:ss"),
						user_id: this.stateUser?.id,
						petugas_id: this.stateUser?.id,
					}
				: null,
			tanda_vital: !this.isDoa && this.isAnyTandaVitalInputed
				? {
						id: this.ttvId,
						sistole: this.tvSistole,
						diastole: this.tvDiastole,
						frekuensi_nadi: this.tvNadi,
						frekuensi_nafas: this.tvNafas,
						suhu_badan: this.tvSuhu,
						saturasi_oksigen: this.tvSaturasiO2,
						unit_id: this.stateUser.unit_id,
					}
				: null,
		};
	}

	mounted() {
		this.getData();
	}

	async save() {
		if (this.readOnly || this.terkunci) return;

		this.saving = true;

		try {
			const resp = this.id
				? await AsesmenSurveyPrimerGadar.update(this.id, this.input)
				: await AsesmenSurveyPrimerGadar.create(this.input);

			if (resp) {
				appModule.NoticeDelay("Berhasil Simpan Asesmen Awal IGD");

				await this.sinkronTriase();

				await this.getData();
			}
		} catch (err) {
			//
		} finally {
			this.saving = false;
		}
	}

	print() {
		AsesmenAwalGadar.printByRegister(this.register);
	}

	remove() {
		if (this.readOnly) return;
		const q = confirm("Hapus Asesmen Survey Primer?");

		if (q) {
			this.deleteData();
		}
	}

	async deleteData() {
		if (this.readOnly) return;
		const del = await AsesmenSurveyPrimerGadar.destroy(this.id);

		if (del?.status == 1) {
			appModule.NoticeDelay("Berhasil Hapus Asesmen Survey Primer");

			await this.getData();
		} else {
			alert("ada kesalahan dalam menghapus data");
		}
	}

	mulaiRetriase() {
		if (this.readOnly || !this.id) return;

		const q = confirm(
			"Mulai retriase? Isian akan dikosongkan dan tersimpan sebagai Survey Primer baru. Survey sebelumnya tetap tersimpan di riwayat.",
		);

		if (!q) return;

		this.clearInput();
		this.modeRetriase = true;
	}

	batalRetriase() {
		this.getData();
	}

	async sinkronTriase() {
		const kategori = triaseLevelToKategoriId(this.triase.level);

		if (kategori === null) return;

		await AsesmenSurveyPrimerGadar.syncTriase(this.register, kategori);
	}

	async muatRiwayat() {
		this.riwayat = await AsesmenSurveyPrimerGadar.getRiwayat(
			this.register,
		).catch(() => []);
		this.expandedRiwayat = [];
	}

	nomorRiwayat(item) {
		const idx = this.riwayat.findIndex(({ id }) => id === item.id);

		return idx < 0 ? "-" : this.riwayat.length - idx;
	}

	isRiwayatTerkini(item) {
		return this.riwayat.length > 0 && this.riwayat[0].id === item.id;
	}

	waktuRiwayat(item) {
		return item?.created_at
			? moment(item.created_at).format("DD-MM-YYYY HH:mm")
			: "-";
	}

	petugasRiwayat(item) {
		return item?.content?.user?.nama || "-";
	}

	triaseRiwayat(item) {
		const c = item?.content ?? {};

		return deriveTriaseSurveyPrimer(
			toTriaseInput({
				airway: c.a_airway,
				pernapasan: c.b_pernapasan,
				pernapasanType: c.b_pernapasan_type,
				klinis: c.b_klinis,
				dada: c.b_dada,
				nadi: c.c_nadi,
				kulit: c.c_kulit,
				akral: c.c_akral,
				crt: c.c_crt,
				kesadaran: c.d_kesadaran,
				pupilReflek: c.d_pupil_reflek,
				reflekCahaya: c.d_reflek_cahaya,
				eksposur: c.e_eksposur,
				isDoa: c.is_doa,
			}),
		);
	}

	temuanRiwayat(item) {
		const teks = this.triaseRiwayat(item).reasons.join(" ");

		return teks.length > 130 ? `${teks.slice(0, 130)}…` : teks;
	}

	namaOpsi(options, id) {
		if (id == null || id === "") return null;

		const found = options.find(o => o.id === id);

		return found ? found.name : String(id);
	}

	namaOpsiBanyak(options, ids) {
		if (!Array.isArray(ids) || !ids.length) return null;

		return ids
			.map(id => this.namaOpsi(options, id))
			.filter(nama => !!nama)
			.join(", ");
	}

	rincianRiwayat(item) {
		const c = item?.content ?? {};
		const tv = c.tanda_vital;
		const gcs = c.gcs;

		const td =
			tv && (tv.tensi?.sistole || tv.tensi?.diastole)
				? `${tv.tensi?.sistole ?? "-"}/${tv.tensi?.diastole ?? "-"} mmHg`
				: null;

		const ttv = tv
			? [
					td,
					tv.nadi != null ? `N ${tv.nadi} x/mnt` : null,
					tv.nafas != null ? `RR ${tv.nafas} x/mnt` : null,
					tv.suhu != null ? `S ${tv.suhu} °C` : null,
					tv.saturasi != null ? `SpO2 ${tv.saturasi}%` : null,
				]
					.filter(x => !!x)
					.join(" · ")
			: null;

		const nilaiGcs =
			gcs && (gcs.eye != null || gcs.verbal != null || gcs.motor != null)
				? `E${gcs.eye ?? "-"} V${gcs.verbal ?? "-"} M${gcs.motor ?? "-"}`
				: null;

		const baris = [
			{ label: "Airway", nilai: this.namaOpsiBanyak(this.airwayOptions, c.a_airway) },
			{
				label: "Breathing",
				nilai: [
					this.namaOpsi(this.pernapasanOptions, c.b_pernapasan),
					this.namaOpsi(this.pernapasanTypeOptions, c.b_pernapasan_type),
					this.namaOpsi(this.dadaOptions, c.b_dada),
					this.namaOpsiBanyak(this.klinisOptions, c.b_klinis),
				]
					.filter(x => !!x)
					.join(", "),
			},
			{
				label: "Circulation",
				nilai: [
					this.namaOpsiBanyak(this.nadiOptions, c.c_nadi),
					this.namaOpsi(this.kulitOptions, c.c_kulit),
					this.namaOpsi(this.akralOptions, c.c_akral),
					this.namaOpsi(this.crtOptions, c.c_crt),
				]
					.filter(x => !!x)
					.join(", "),
			},
			{
				label: "Disability",
				nilai: [
					this.namaOpsi(this.kesadaranOptions, c.d_kesadaran),
					this.namaOpsi(this.pupilReflekOptions, c.d_pupil_reflek),
					c.d_pupil_diameter ? `diameter ${c.d_pupil_diameter}` : null,
					c.d_reflek_cahaya ? `reflek cahaya ${c.d_reflek_cahaya}` : null,
					this.namaOpsi(this.lateralisasiOptions, c.d_lateralisasi),
				]
					.filter(x => !!x)
					.join(", "),
			},
			{
				label: "Exposure",
				nilai: this.namaOpsiBanyak(this.eksposurOptions, c.e_eksposur),
			},
			{ label: "Tanda Vital", nilai: ttv },
			{ label: "GCS", nilai: nilaiGcs },
			{
				label: "Nyeri",
				nilai: c.nyeri && c.nyeri.skala != null ? `skala ${c.nyeri.skala}` : null,
			},
		];

		return baris.filter(({ nilai }) => !!nilai);
	}

	async getData() {
		const reg = this.register;

		await this.hydrate(async () => {
			this.modeRetriase = false;

			await AsesmenSurveyPrimerGadarStore.getByRegister(reg);
			await this.muatRiwayat();

			if (reg !== this.register) return;

			const data = this.storeSurvey.asesmen;

			if (data) {
				const ctn = data.content;

				this.id = data?.id;
				this.airway = ctn?.a_airway;
				this.pernapasan = ctn?.b_pernapasan;
				this.dada = ctn?.b_dada;
				this.pernapasanType = ctn?.b_pernapasan_type;
				this.klinis = ctn?.b_klinis;
				this.nadi = ctn?.c_nadi;
				this.kulit = ctn?.c_kulit;
				this.akral = ctn?.c_akral;
				this.crt = ctn?.c_crt;
				this.kesadaran = ctn?.d_kesadaran;
				this.reflekCahaya = ctn?.d_reflek_cahaya;
				this.pupilDiameter = ctn?.d_pupil_diameter;
				this.pupilReflek = ctn?.d_pupil_reflek;
				this.lateralisasi = ctn?.d_lateralisasi;
				this.eksposur = ctn?.e_eksposur;
				this.isDoa = !!ctn?.is_doa;

				if (ctn?.asesmenAnak) {
					this.asesmenAnakId = ctn.asesmenAnak.id;
					this.valAsesmenAnak = ctn.asesmenAnak;
				} else {
					this.resetAsesmenAnak();
				}

				if (ctn.tanda_vital) {
					this.ttvId = ctn.tanda_vital.id;
					this.tvSistole = ctn.tanda_vital.tensi?.sistole;
					this.tvDiastole = ctn.tanda_vital.tensi?.diastole;
					this.tvNadi = ctn.tanda_vital.nadi;
					this.tvNafas = ctn.tanda_vital.nafas;
					this.tvSuhu = ctn.tanda_vital.suhu;
					this.tvSaturasiO2 = ctn.tanda_vital.saturasi;
				}

				if (ctn.nyeri) {
					this.nyeriId = ctn.nyeri.id;
					this.nyeriSkala = ctn.nyeri.skala;
					this.nyeriLokasi = ctn.nyeri.lokasi;
					this.nyeriFrekuensi = ctn.nyeri.frekuensi;
					this.nyeriDurasi = ctn.nyeri.durasi;
					this.nyeriPencetus = ctn.nyeri.pencetus;
					this.nyeriKualitas = ctn.nyeri.kualitas;
					this.nyeriPolaSerangan = ctn.nyeri.pola_serangan;
					this.nyeriPenyebabHilang = ctn.nyeri.penyebab_hilang;
					this.nyeriJenis = ctn.nyeri.jenis;
				}

				if (ctn.gcs) {
					this.asesKesadaranId = ctn.gcs.id;
					this.gcsEye = ctn.gcs.eye;
					this.gcsVerbal = ctn.gcs.verbal;
					this.gcsMotor = ctn.gcs.motor;
				}

				if (ctn.risiko_jatuh) {
					this.asesRisjatId = ctn.risiko_jatuh.id;
					this.asesRisjat = ctn.risiko_jatuh.level;
				}

				if (ctn.kecemasan) {
					this.asesKecemasanId = ctn.kecemasan.id;
					this.asesKecemasan = ctn.kecemasan.level;
				}
			} else {
				this.clearInput();
				this.resetAsesmenAnak();
			}
		});
	}

	async getDataById(id) {
		const resp = await AsesmenSurveyPrimerGadar.find(id);

		console.log("resp survey primer", resp);
	}

	resetAsesmenAnak() {
		this.asesmenAnakId = null;
		this.anakDownScore = null;
		this.anakApgar1min = null;
		this.anakApgar5min = null;
		this.anakBeratBadan = null;
		this.anakTinggiBadan = null;
		this.anakSaga = sagaItemsKosong();
		this.anakDown = downItemsKosong();
	}

	clearInput() {
		this.id = null;
		this.isDoa = false;

		this.airway = [];
		this.pernapasan = null;
		this.dada = null;
		this.pernapasanType = null;
		this.klinis = null;
		this.nadi = null;
		this.kulit = null;
		this.akral = null;
		this.crt = null;
		this.kesadaran = null;
		this.pupilReflek = null;
		this.pupilDiameter = null;
		this.reflekCahaya = null;
		this.lateralisasi = null;
		this.eksposur = null;

		this.tvSistole = null;
		this.tvDiastole = null;
		this.tvNadi = null;
		this.tvNafas = null;
		this.tvSuhu = null;
		this.tvSaturasiO2 = null;
		this.ttvId = null;

		this.gcsEye = null;
		this.gcsVerbal = null;
		this.gcsMotor = null;
		this.asesKesadaranId = null;

		this.asesRisjat = null;
		this.asesRisjatId = null;

		this.asesKecemasan = null;
		this.asesKecemasanId = null;

		this.nyeriSkala = 0;
		this.nyeriLokasi = null;
		this.nyeriFrekuensi = null;
		this.nyeriDurasi = null;
		this.nyeriPencetus = null;
		this.nyeriKualitas = null;
		this.nyeriPolaSerangan = null;
		this.nyeriPenyebabHilang = null;
		this.nyeriJenis = null;
		this.nyeriId = null;

		// isian default req dr.hanum per 02-01-22
		// this.airway = [6];
		// this.pernapasan = 1;
		// this.dada = 1;
		// this.pernapasanType = 1;
		// this.klinis = [1];
		// this.nadi = [1, 3];
		// this.kulit = 1;
		// this.akral = 1;
		// this.crt = 1;
		// this.kesadaran = 1;
		// this.pupilReflek = 1;
		// this.pupilDiameter = "3/3";
		// this.reflekCahaya = "+/+";
		// this.lateralisasi = 0;

		// this.gcsEye = 4;
		// this.gcsVerbal = 5;
		// this.gcsMotor = 6;
	}

	get valNyeri(): Nyeri {
		return {
			skala: this.nyeriSkala,
			lokasi: this.nyeriLokasi,
			frekuensi: this.nyeriFrekuensi,
			durasi: this.nyeriDurasi,
			pencetus: this.nyeriPencetus,
			kualitas: this.nyeriKualitas,
			pola_serangan: this.nyeriPolaSerangan,
			penyebab_hilang: this.nyeriPenyebabHilang,
			jenis: this.nyeriJenis,
		};
	}

	set valNyeri(val) {
		this.nyeriSkala = val.skala;
		this.nyeriLokasi = val.lokasi;
		this.nyeriFrekuensi = val.frekuensi;
		this.nyeriDurasi = val.durasi;
		this.nyeriPencetus = val.pencetus;
		this.nyeriKualitas = val.kualitas;
		this.nyeriPolaSerangan = val.pola_serangan;
		this.nyeriPenyebabHilang = val.penyebab_hilang;
		this.nyeriJenis = val.jenis;
	}

	get valAsesmenAnak(): AsesmenAnakGadarValue {
		return {
			downScore: this.anakDownScore,
			apgar1min: this.anakApgar1min,
			apgar5min: this.anakApgar5min,
			bb: this.anakBeratBadan,
			tb: this.anakTinggiBadan,
			saga: { ...this.anakSaga },
			downItems: { ...this.anakDown },
		};
	}

	set valAsesmenAnak(val: AsesmenAnakGadarValue) {
		this.anakDownScore = val?.downScore ?? null;
		this.anakApgar1min = val?.apgar1min ?? null;
		this.anakApgar5min = val?.apgar5min ?? null;
		this.anakBeratBadan = val?.bb ?? null;
		this.anakTinggiBadan = val?.tb ?? null;

		const src = sagaNormalizeItems(val?.saga);

		SAGA_KEYS.forEach((key) => {
			if (this.anakSaga[key] !== src[key]) {
				this.anakSaga[key] = src[key];
			}
		});

		const srcDown = downNormalizeItems(val?.downItems);

		DOWN_KEYS.forEach((key) => {
			if (this.anakDown[key] !== srcDown[key]) {
				this.anakDown[key] = srcDown[key];
			}
		});
	}

	get valTtv(): TTV {
		return {
			sistole: this.tvSistole,
			diastole: this.tvDiastole,
			nadi: this.tvNadi,
			nafas: this.tvNafas,
			suhu: this.tvSuhu,
			saturasiO2: this.tvSaturasiO2,
		};
	}

	set valTtv(val: TTV) {
		this.tvSistole = val.sistole;
		this.tvDiastole = val.diastole;
		this.tvNadi = val.nadi;
		this.tvNafas = val.nafas;
		this.tvSuhu = val.suhu;
		this.tvSaturasiO2 = val.saturasiO2;
	}

	get gcs() {
		return {
			e: this.gcsEye,
			v: this.gcsVerbal,
			m: this.gcsMotor,
		};
	}

	get isAnyAsesKesadaranInputed() {
		if (
			this.asesKesadaranId ||
			this.gcsEye ||
			this.gcsVerbal ||
			this.gcsMotor
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesKecemasanInputed() {
		if (this.asesKecemasanId || this.asesKecemasan !== null) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesNyeriInputed() {
		if (
			this.nyeriId ||
			this.nyeriSkala ||
			this.nyeriLokasi ||
			this.nyeriFrekuensi ||
			this.nyeriDurasi ||
			this.nyeriPencetus ||
			this.nyeriKualitas ||
			this.nyeriPolaSerangan ||
			this.nyeriPenyebabHilang ||
			this.nyeriJenis
		) {
			return true;
		} else {
			return false;
		}
	}

	get isAnyAsesRisjatInputed() {
		return this.asesRisjatId || this.asesRisjat !== null ? true : false;
	}

	get isAnyTandaVitalInputed() {
		if (
			this.ttvId ||
			this.tvSistole ||
			this.tvDiastole ||
			this.tvNadi ||
			this.tvNafas ||
			this.tvSuhu ||
			this.tvSaturasiO2
		) {
			return true;
		} else {
			return false;
		}
	}

	setNyeri(val: Nyeri) {
		this.valNyeri = val;
	}

	setTtv(val: TTV) {
		this.valTtv = val;
	}

	setAsesmenAnak(val: AsesmenAnakGadarValue) {
		this.valAsesmenAnak = val;
	}

	setGcs(val) {
		this.gcsEye = val.e;
		this.gcsVerbal = val.v;
		this.gcsMotor = val.m;
	}

	setRisikoJatuh(val) {
		this.asesRisjat = val;
	}

	setKecemasan(val) {
		this.asesKecemasan = val;
	}
}
